<div class="w-full mb-6">
    @if(showLabels()) {
    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
        {{ label() ?? 'Upload Image' }}
    </label>
    @if (subTitle()) {
    <p class="text-xs text-primary-300 block">{{ subTitle() }}</p>
    }
    <p class="text-xs text-primary-300">Image file up to 5 Mb only</p>
    }
    <div class="flex flex-row gap-4 w-full {{ showLabels() ? 'mt-2' : ''}}">
        <div class="rounded h-[130px] grow">
            <uppy-dashboard [uppy]="uppy" [props]="dashboardProps"></uppy-dashboard>
        </div>
    </div>
</div>